import { FidelityStatus } from '../interfaces/fidelity';

export const FIDELITY_STATUSES = [
  { value: FidelityStatus.BOZZA, label: 'Bozza', color: 'gray' },
  {
    value: FidelityStatus.IN_APPROVAZIONE,
    label: 'In approvazione',
    color: 'yellow',
  },
  { value: FidelityStatus.APPROVATO, label: 'Approvato', color: 'green' },
  { value: FidelityStatus.RIFIUTATO, label: 'In revisione', color: 'red' },
  { value: FidelityStatus.SCADUTO, label: 'Scaduto', color: 'gray' },
  { value: FidelityStatus.TERMINATO, label: 'Terminato', color: 'orange' },
];

export const DISCOUNT_VALUES = Array.from({ length: 20 }, (_, i) => ({
  value: (i + 1) * 5,
  label: `${(i + 1) * 5}%`,
}));

export const DISCOUNT_FILTER_OPTIONS = [
  { value: '0-5', label: '0-5%' },
  { value: '5-10', label: '5-10%' },
  { value: '10-15', label: '10-15%' },
  { value: '15-20', label: '15-20%' },
  { value: '20+', label: '≥20%' },
];

export function parseDiscountValue(value: string) {
  if (value.includes('+')) {
    const min = parseInt(value.split('+')[0]);
    return { min, max: null };
  }
  const [min, max] = value.split('-');
  return { min: parseInt(min), max: parseInt(max) };
}

export const getStatusLabel = (status: FidelityStatus) => {
  const statusObj = FIDELITY_STATUSES.find((s) => s.value === status);
  return statusObj?.label || status;
};

export const getStatusColor = (status: FidelityStatus) => {
  const statusObj = FIDELITY_STATUSES.find((s) => s.value === status);
  return statusObj?.color || 'gray';
};

export const formatDiscount = (discount: number) => {
  return `${discount}%`;
};
